import * as Yup from "yup";



export const initialValues = {
  company: null,
  position: null,
  latestSalary: null,
  startDate: null,
  endDate: null,
  responsibility: null,

};

const EmployeeInfoWorkExperienceSchema = Yup.object().shape({
  company: Yup.string().required("Please enter company name."),
  position: Yup.string().required("Please enter latest position"),
  startDate: Yup.string().required("Please enter latest start date"),
  endDate: Yup.string().required("Please enter latest end date"),
  // dateOfBirth: Yup.string().required("Please select date of birth."),
  // genderId: Yup.string().required("Please select gender"),
  // employeeNationality: Yup.string().required("Please select nationality."),
  // // raceId: Yup.string().required("Please select race."),
  // // nationalityId: Yup.string().required("Please select nationality."),
  // religionId: Yup.string().required("Please select religion."),
  // maritalStatusId: Yup.string().required("Please select marital status."),
  // militaryStatusId: Yup.string().required("Please select military status."),
  // bloodGroupId: Yup.string().required("Please blood group."),
  // weight: Yup.string().required("Please enter weight."),
  // height: Yup.string().required("Please enter height."),
});

export default EmployeeInfoWorkExperienceSchema;
